import { Sparkles } from 'lucide-react';
import { cn } from '@clarix/ui';

interface ClaraIconProps {
  className?: string;
  animate?: boolean;
}

export function ClaraIcon({ className, animate }: ClaraIconProps) {
  return (
    <div
      aria-label="Clara"
      className={cn(
        'inline-flex items-center justify-center',
        animate && 'animate-pulse',
        className,
      )}
    >
      <Sparkles className="h-6 w-6 text-indigo-500" strokeWidth={2.5} />
    </div>
  );
}
